module.exports = __webpack_public_path__ + "assets/img/dough.f0e7b0ab.png";